export const REFRESH_USER_BALANCE_START =
  'REFRESH_USER_BALANCE_START';
export const REFRESH_USER_BALANCE_SUCCESS =
  'REFRESH_USER_BALANCE_SUCCESS';
export const REFRESH_USER_BALANCE_FAILED =
  'REFRESH_USER_BALANCE_FAILED';
